"use client";
import { useEffect, useImperativeHandle, useRef, type Ref, type PointerEvent } from "react";
export type SignaturePadHandle = { image: () => string };
export function SignaturePad({ ref, disabled, onChange }: { ref: Ref<SignaturePadHandle>; disabled: boolean; onChange: (written: boolean) => void }) {
  const canvas = useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const distance = useRef(0);
  const last = useRef({ x: 0, y: 0 });
  useImperativeHandle(ref, () => ({ image: () => canvas.current?.toDataURL("image/png").split(",")[1] ?? "" }), []);
  const clear = () => {
    const ctx = canvas.current?.getContext("2d"); if (!ctx) return;
    ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, 600, 220); ctx.strokeStyle = "#111"; ctx.lineWidth = 3; ctx.lineCap = "round"; ctx.lineJoin = "round";
    distance.current = 0; drawing.current = false;
  };
  useEffect(clear, []);
  const point = (event: PointerEvent<HTMLCanvasElement>) => { const rect = event.currentTarget.getBoundingClientRect(); return { x: (event.clientX - rect.left) * 600 / rect.width, y: (event.clientY - rect.top) * 220 / rect.height }; };
  return <>
    <canvas ref={canvas} width={600} height={220} aria-label="手写签名区域" className="rg-sign-canvas" onPointerDown={event => {
      if (disabled || !event.isPrimary || event.button !== 0) return;
      event.preventDefault(); drawing.current = true; last.current = point(event); event.currentTarget.setPointerCapture(event.pointerId);
    }} onPointerMove={event => {
      if (disabled || !drawing.current) return;
      const ctx = canvas.current?.getContext("2d"); if (!ctx) return;
      const next = point(event); ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(next.x, next.y); ctx.stroke();
      distance.current += Math.hypot(next.x - last.current.x, next.y - last.current.y); last.current = next;
      if (distance.current > 30) onChange(true);
    }} onPointerUp={() => { drawing.current = false; }} onPointerCancel={() => { drawing.current = false; }} />
    <button type="button" className="rg-refresh" disabled={disabled} onClick={() => { clear(); onChange(false); }}>重新签名</button>
  </>;
}
